import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface OffersFunnelState {
  step: number;
  setStep: (step: number) => void;
  reset: () => void;
}

/**
 * Current position in the post-purchase funnel. Persisted so a refresh resumes
 * on the same offer; reset when a new checkout succeeds.
 */
export const useOffersFunnelStore = create<OffersFunnelState>()(
  persist(
    (set) => ({
      step: 0,
      setStep: (step) => set({ step }),
      reset: () => set({ step: 0 }),
    }),
    {
      name: 'bp-offers-funnel',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
